import { environment } from '../../../environments/environment';

export const APP_CONFIG = {
  API_URL: environment.api_url,
  APP_VERSION: environment.app_version,
  APP_ENV: environment.env,
  WS_PING_INTERVAL: environment.ws_ping_interval ?? 60000,
  RECONNECT_INTERVAL: environment.ws_reconnect_interval ?? 5000
  // SENTRY_DSN: environment.sentry_dsn, // @TODO add sentry
};
